import React from 'react';
import { Box, Typography } from '@mui/material';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  variant?: 'default' | 'large';
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  variant = 'default',
}) => {
  return (
    <Box
      sx={{
        width: '300px',
        maxWidth: '500px',
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography
        variant={variant === 'large' ? 'h4' : 'h6'}
        sx={{ fontWeight: 600, color: '#1a237e' }}
      >
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
